import { z } from "zod";

export const createVehicleResponseSchema = z.object({
  uuid: z.uuid().nullable(),
});

export type CreateVehicleResponse = z.infer<typeof createVehicleResponseSchema>;
